module.exports = __webpack_public_path__ + "static/media/onda-violeta.768bd75d.png";